//
//  decorators.ts
//  moods-film-ui
//
//  Created by romain@lunii on 15/09/2019.
//  Copyright © 2019 Lunii. All rights reserved.
//

import { createDecorator } from 'vue-class-component';

export const Meta = createDecorator((options: any, key: any) => {

    if (!options.methods) { return; }

    options.metaInfo = options.methods[key];

});
